<template>
    <div :class="classes">
        <div v-if="showHeader" :class="namespace('header')">
            <span :class="namespace('header__title')">
                <slot name="title"></slot>
            </span>
            <div :class="mdsNS('popover__overlay')"></div>
            <div :class="mdsNS('button-icon-wrap')">
                <button
                    v-if="showExport"
                    ref="exportButton"
                    :class="exportBtnClassess"
                    type="button"
                    @click.stop="clickExport"
                >
                    <svg aria-hidden="true" :class="mdsNS('icon button__icon')">
                        <use xlink:href="#share">
                            <title>Settings</title>
                        </use>
                    </svg>
                </button>
                <button
                    v-if="showSetting"
                    ref="settingsButton"
                    :class="settingBtnClassess"
                    type="button"
                    @click.stop="clickSetting"
                >
                    <svg aria-hidden="true" :class="mdsNS('icon button__icon')">
                        <use xlink:href="#gear">
                            <title>Settings</title>
                        </use>
                    </svg>
                </button>
            </div>
        </div>
        <div :class="namespace('body')">
            <markets-ui-alert
                v-if="!!errorMessage"
                :namespaced="namespaced"
                :class="namespace('body-alert')"
                :message="errorMessage"
                :skin="skin"
                :visible="!!errorMessage"
            ></markets-ui-alert>
            <slot name="content"></slot>
        </div>
        <markets-ui-loading
            :namespaced="namespaced"
            :skin="skin"
            :visible="showLoading"
        ></markets-ui-loading>
    </div>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-container',
    mixins: [mixins],
    props: {
        showBorder: {
            type: Boolean,
            default: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showSetting: {
            type: Boolean,
            default: false
        },
        showExport: {
            type: Boolean,
            default: false
        },
        showLoading: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ''
        }
    },
    computed: {
        classes() {
            const array = [this.namespace()];
            if (!this.showBorder) {
                array.push(this.namespace('__no-border'));
            }
            if (!this.showHeader) {
                array.push(this.namespace('__no-header'));
            }
            if (this.skin) {
                array.push(
                    this.namespace(`__${utils.getSkinSuffix(this.skin)}`)
                );
            }
            return array;
        },
        settingBtnClassess() {
            return `${this.mdsNS(
                'button button--icon-only button--small popover__trigger'
            )} ${this.namespace('header__settings')}`;
        },
        exportBtnClassess() {
            return `${this.mdsNS(
                'button button--icon-only button--small popover__trigger'
            )} ${this.namespace('header__export')}`;
        }
    },
    created() {
        this.namespace = utils.namespace('ui-container', false);
    },
    methods: {
        clickSetting() {
            this.$emit('setting-click', this.$refs.settingsButton);
        },
        clickExport() {
            this.$emit('export-click', this.$refs.exportButton);
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-container';
.#{$namespace} {
    font-family: $mds-font-family-sans-serif;
    td,
    span,
    p {
        font-family: $mds-font-family-sans-serif;
    }
    position: relative;
    background: $mds-color-white;
    border: solid 1px $mds-color-neutral-67;
    height: calc(100% - 2px);
    &-header {
        background: $mds-color-neutral-80;
        height: $mds-size-element-height-m;
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 0 $mds-space-inset-half-x;
        border-bottom: solid 1px $mds-color-neutral-67;
        &__bold {
            font-weight: $mds-font-weight-bold;
        }
        &__title {
            font-weight: $mds-font-weight-bold;
            font-size: $mds-font-size-s;
            color: $mds-color-neutral-37;
        }
    }
    &-body {
        height: calc(100% - 30px);
        &-alert {
            padding: 10px;
        }
    }

    &__no-border {
        border: none;
        height: 100%;
    }
    &__no-header {
        .#{$namespace}-body {
            height: 100%;
        }
    }
    &__dark-gray {
        .#{$namespace}-body {
            background: $mds-background-color-dark-gray;
        }
    }
}
</style>
